import React, { useState, useMemo, useEffect } from "react";
import { useLocation, useParams } from "react-router";
import { useManageSecurityGroupsAPI } from "../../hooks/useManageSecurityGroupsAPI.js";
import useManageSecurityGroup from "../../hooks/useManageSecurityGroup.js";
import { toast } from "react-toastify";
import Table from "../Content/MaterialTable/index.jsx";
import SecurityFilterModal from "../ManageModals/SecurityFilterModal.js";
import { useForm } from "react-hook-form";
import CreateSecurityGroup from "../CreateSecurityGroup/index.jsx";

const CONTROL = {
  InternalName: "",
};

const SEARCH_DATA = {
  InternalName: ""
};

const ManageSecurityGroups = () => {
  const location = useLocation();
  const { id } = useParams();
  const [groupRecord, setGroupRecord] = React.useState({});
  const [page, setPage] = React.useState(1);
  const [sort] = React.useState([]);
  const [searchData, setSearchData] = React.useState({ ...SEARCH_DATA });
  const [controls, setControl] = useState({ ...CONTROL });
  const { control, setValue } = useForm({
    defaultValues: {
      InternalName: ""
    },
  });
  const {
    data: list,
    isLoadingList,
    refetchList,
    handledeleteSecurityGroups,
  } = useManageSecurityGroupsAPI({
    id,
    page,
    enabled: true,
    sort,
    ...searchData,
  });
  const onSearch = () => {
    setPage(1);
    setSearchData({
      InternalName: controls["InternalName"],
    });
  };
  useEffect(() => {
    setControl({ ...CONTROL });
    setSearchData({ ...SEARCH_DATA });
  }, [location.pathname]);
  const { createMutation, updateMutation } = useManageSecurityGroup({
    id: groupRecord.id,
  });

  const [openModal, setOpenModal] = React.useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [rowSelection, setRowSelection] = useState([]);
  const handleToggle = (isCreate) => {
    if (isCreate) setGroupRecord({ ...{} });
    setOpenModal((prev) => !prev);
  };

  const onEditClick = (record) => {
    setGroupRecord({ ...record.original });
    setOpenModal(true);
  };
  const handleCreate = () => {
    setGroupRecord({ ...{} });
    setOpenModal(false);
    refetchList();
    toast.success(
      groupRecord.id
        ? "Security Group updated successfully"
        : "Security Group created successfully"
    );
  };

  const groupsList = useMemo(() => {
    return list ?? [];
  }, [list]);
  const columns = useMemo(
    () => [
      {
        accessorKey: "internalName",
        header: "Internal Name",
        size: 150,
      },
      {
        accessorKey: "displayName",
        header: "Display Name",
        size: 150,
      },

    ],
    []
  );
  const isNextButtonDisabled = list?.length === 0 || list?.length % 20 !== 0;

  const isPrevButtonDisabled = page === 1;

  const handleBack = () => {
    setRowSelection({});
    setPage((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setRowSelection({});
    if (isNextButtonDisabled) return;
    setPage((prev) => prev + 1);
  };
  const handlecChangeDropdown = (key, val) => {
    const copyControl = { ...controls };

    copyControl[key] = val;
    setControl((prev) => ({ ...prev, ...copyControl }));
    setValue(key, val);
  };
  const handleReset = () => {
    setControl({ ...CONTROL });
    setSearchData({ ...SEARCH_DATA });
  };
  return (
    <div>
      <div style={{ display: "flex", alignContent: "center" }}>
        <h5 style={{ marginLeft: 8 }}>Security Groups</h5>
      </div>
      {openModal && (
        <CreateSecurityGroup
          key={id}
          open={openModal}
          handleClose={handleToggle}
          createMutation={createMutation}
          updateMutation={updateMutation}
          onSuccess={handleCreate}
          userId={id}
          groupRecord={groupRecord}
        />
      )}
      {showFilter && (
        <SecurityFilterModal
          isModalOpen={showFilter}
          hideModal={() => setShowFilter(false)}
          handlecChangeDropdown={handlecChangeDropdown}
          onSearch={onSearch}
          clear={handleReset}
          control={control}
          controls={controls}
        />
      )}
      {location.pathname?.includes("managesecuritygroups") && (
        <Table
          columns={columns}
          setRowSelection={setRowSelection}
          rowSelection={rowSelection}
          handleToggle={handleToggle}
          onEditClick={onEditClick}
          isLoadingList={isLoadingList}
          data={groupsList}
          handleBack={handleBack}
          handleNext={handleNext}
          isNextButtonDisabled={isNextButtonDisabled}
          isNextPrevDisabled={isPrevButtonDisabled}
          handleDelete={handledeleteSecurityGroups}
          type={"groups"}
          setSearchData={setSearchData}
          showModalFilter={setShowFilter}
        />
      )}
    </div>
  );
};

export default ManageSecurityGroups;
